<!--
 * @Author: wangwei
 * @Date: 2023-05-10 11:38:58
 * @LastEditTime: 2023-05-10 13:33:23
 * @LastEditors: wangwei
 * @Description: 
 * @FilePath: \会务系统\会务个人中心\src\views\rolesDel.vue
 *  
-->
<template>
  <div class="role">
    <div>
      <div style="margin-bottom: 12px;text-align: center;">
        <svg t="1683690845402" class="icon" viewBox="0 0 1024 1024" version="1.1" xmlns="http://www.w3.org/2000/svg" p-id="4069" width="200" height="200">
          <path d="M802.594595 83.027027c76.426378 0 138.378378 61.952 138.378378 138.378378v581.18919c0 76.426378-61.952 138.378378-138.378378 138.378378H221.405405c-76.426378 0-138.378378-61.952-138.378378-138.378378V221.405405c0-76.426378 61.952-138.378378 138.378378-138.378378h581.18919zM221.405405 0C99.120432 0 0 99.120432 0 221.405405v581.18919c0 122.284973 99.120432 221.405405 221.405405 221.405405h581.18919c122.284973 0 221.405405-99.120432 221.405405-221.405405V221.405405c0-122.284973-99.120432-221.405405-221.405405-221.405405H221.405405z m140.052757 420.172108a41.513514 41.513514 0 1 1 58.713946-58.713946l88.064 88.064 88.064-88.064a41.513514 41.513514 0 1 1 58.700108 58.713946l-88.050162 88.064 88.064 88.064a41.513514 41.513514 0 1 1-58.713946 58.700108l-88.064-88.050162-88.064 88.064a41.513514 41.513514 0 0 1-58.713946-58.713946l88.064-88.064-88.064-88.064z" fill="#000000" p-id="4070"></path>
        </svg>
      </div>
      当前活动链接已失效
    </div>
  </div>
</template>

<script>
export default {
  data () {
    return {

    }
  },
}
</script>

<style lang="scss" scoped>
.role {
  display: inline-flex;
  justify-content: center;
  align-items: center; // stretch; // center; // start; // end; // baseline; // between;
  width: 100%;
  height: 100vh;
  .icon {
    width: 4em;
    height: 4em;
    // display: block;
  }
}
</style>